<div *transloco="let t; prefix: 'trialRemainingDays'">
  <rma-icon glyph="access_time" />
  <p class="days-left">{{ t('daysLeft', { count: trialDays }) }}</p>
  <a class="subscribe desktop" mat-raised-button color="accent" routerLink="/billing/plans">{{ t('subscribe') }}</a>
  <a class="subscribe mobile" routerLink="/billing/plans">{{ t('subscribe') }}</a>
</div>
